

import {
  Box,
  Button,
  Divider,
  Grid,
  IconButton,
  MenuItem,
  Select,
  TextField,
  Typography,
  Checkbox,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { Clear, DeleteOutline } from "@mui/icons-material";
import { DemoContainer, DemoItem } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import moment from "moment";

import { color } from "../../../StyleData/Config";
import { axiosPrivate } from "../../../axios/axios";
import { masterAPI } from "../dataConfig";
import { DesktopDatePicker } from "@mui/lab";
import { DateTimePicker } from "@mui/x-date-pickers";
import { toast } from "react-toastify";
import NormalTable from "../../../Component/NormalTable";
import { menulist } from "../../../SampleData/PMSample";

const LicenceUserTypeMenusModal = ({ mode, handleCloseClick, editData, getById }) => {
  const [loading, setLoading] = useState(false);
  const [menuSelect, setMenusSelect] = useState([]);
  const [menusMaster, setMenusMaster] = useState([]);
  const [alreadySelMenu,setAlreadySelMenu]=useState([])

  useEffect(() => {
    getData();
  }, []);
  const getData = () => {
    const menusLink = masterAPI["menus"].getMasterMenusOrg;
    axiosPrivate
      .get(`${menusLink}`)
      .then((res) => {
        setLoading(false);
        setMenusMaster(res.data.result);
        console.log("menus", res.data.result);
      })
      .catch((e) => {
        setMenusMaster([]);
        setLoading(false);
        console.log(e, "error");
      });
    if (mode === "Edit" && editData) {
      setAlreadySelMenu(editData.licenceMenusList || []);
    }
  };
  const initialValue = {
    userTypeName: mode === "Edit" ? editData.userTypeName : "",
    code: mode === "Edit" ? editData.code : "",
    licenceMenusList: mode === "Edit" ? editData.licenceMenusList : [],
  };

  console.log("editData", editData);
  const onSubmit = async (value) => {
    // const licenceMenusList = menuSelect.map((p) => ({
    //   ...(p.id
    //     ? { id: p.id, menuId: p.menuId, licenceUserTypeId: p.licenceUserTypeId, }
    //     : {
    //         id: "00000000-0000-0000-0000-000000000000",
    //         menuId: p.menuId,
    //         licenceUserTypeId: p.licenceUserTypeId,
    //       }),
    // }));
    const payload = {
      ...value,
      licenceMenusList: menuSelect,
    };
    console.log("payload", payload);
    setLoading(true);
    const createLink = masterAPI["licenceUserType"].create;
    const updateLink = masterAPI["licenceUserType"].update;
    if (mode === "Create") {
      await axiosPrivate
        .post(`${createLink}`, payload)
        .then((res) => {
          console.log(res.data);
          setLoading(false);
          handleCloseClick();
        })
        .catch((e) => {
          setLoading(false);
          console.log(e, "create licenceUserType");
        });
    } else {
      const updateAC = {
        id: editData.id,
        ...payload,
      };
      console.log("UpdatePayload", updateAC);
      await axiosPrivate
        .put(`${updateLink}`, updateAC)
        .then((res) => {
          console.log(res.data);
          setLoading(false);
          handleCloseClick();
        })
        .catch((e) => {
          setLoading(false);
          console.log(e, "update licenceUserType");
        });
    }
  };

  const handleCancel = () => {
    handleCloseClick();
  };
  const menusColumns = [
    {
      accessor: "id",
      disableFilters: true,
      Cell: ({ cell }) => {
        const id = cell.row.original.id;

        const isChecked = (menuSelect.some((menu) => menu.menuId === id))||(alreadySelMenu.some((menu) => menu.menuId === id));
        return (
          <Checkbox
            checked={isChecked}
            disabled={(alreadySelMenu.some((menu) => menu.menuId === id))}
            onChange={(e) =>
              handleCheckMenus(e.target.checked, cell.row.original)
            }
            sx={{
                       
                            "&.Mui-disabled":{
                               color:"#1976d2"
                            }
                     
                        
                          
                        }}
          />
        );
      },
    },
    {
      Header: "Menus",
      accessor: "name",
    },
    {
            Header: "Action",
            enableHiding:mode==="Create"?true:false,
            accessor: "isDeleted",
            // isVisible:false,
            Cell:({cell})=>{
              return(
                <IconButton disabled={!(alreadySelMenu.some((menu) => menu.menuId === cell.row.original.id))} onClick={() => {
                    confirmDeleteMenu((alreadySelMenu.filter((fil) => fil.menuId === cell.row.original.id))[0].id);
                  }}>
                <DeleteOutline
                  
                  sx={{
                    fontSize: color.masterEditDelButton,
                    color:!(alreadySelMenu.some((menu) => menu.menuId === cell.row.original.id))?"default": color.masterEditDelButtonColor,
                  }}
                />
              </IconButton>
              )
            }
            // disableFilters: true,
          },
  ];
//   const handleCheckMenus = (menus) => {
//     setMenusSelect((prev) => {
//       const exists = prev.find((p) => p.menuId === menus.id);
//       if (exists) {
//         if (mode === "Edit") {
//           const menuObjectFromEditData = editData.licenceMenusList.find(
//             (r) => r.menuId === menus.id
//           );
//           confirmDeleteMenu(menuObjectFromEditData.id);
//         }
//         return prev.filter((p) => p.menuId !== menus.id);
//       }

//       return [
//         ...prev,
//         {
//           menuId: menus.id,
//           licenceUserTypeId: menus.licenceUserTypeId,
//         },
//       ];
//     });
//   };

   const handleCheckMenus = (checked, menus) => {
    console.log(checked)
console.log(checked)
    if (checked) {
      setMenusSelect([
        ...menuSelect,
        {
          id: "00000000-0000-0000-0000-000000000000",
          menuId: menus.id,
          licenceUserTypeId : editData.id,
        },
      ]);
    } else{
      const filterMenusSelect=menuSelect.filter(fil=>fil.menuId!==menus.id)
      setMenusSelect(filterMenusSelect)
    }
  };
  const confirmDeleteMenu = (id) => {
    toast(
      <Grid>
        <Typography
          sx={{ fontSize: "15px", fontWeight: 600, color: "#797979" }}
        >
          Are you sure you want to remove this menus for this Licence User Type?
        </Typography>
        <Grid item container spacing={2}>
          <Grid item>
            <Button
              onClick={() => {
                handleDeleteMenus(id);
                toast.dismiss();
              }}
              sx={{ color: "grey", borderColor: "green" }}
              size="small"
              variant="outlined"
            >
              Yes
            </Button>
          </Grid>
          <Grid item>
            <Button
              onClick={() => toast.dismiss()}
              sx={{ color: "grey", borderColor: "red" }}
              size="small"
              variant="outlined"
            >
              No
            </Button>
          </Grid>
        </Grid>
      </Grid>,
      {
        closeButton: false,
        autoClose: false,
      }
    );
  };
  const handleDeleteMenus = async (menuId) => {
    const menuDelete = masterAPI["licenceMenus"].delete;
    await axiosPrivate
      .delete(`${menuDelete}/${menuId}`)
      .then((res) => {
        console.log(res);
        console.log("delmenu",menuId)
        var filterMenu = alreadySelMenu.filter((fil) => fil.id !== menuId);
          setAlreadySelMenu(filterMenu);
        // toast.success("Deleted Successfully");
      })
      .catch((e) => {
        console.log(e, "error task delete");
      });
  };
  return (
    <Box sx={{ p: color.masterPageDialogPadding }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <Typography
          sx={{
            color: color.masterDialogTitleColor,
            fontSize: color.masterDialogFontSize,
          }}
        >
          {mode === "Edit"
            ? editData.code + "-" + editData.userTypeName
            : "New Organization"}
        </Typography>
        <IconButton onClick={handleCancel}>
          <Clear />
        </IconButton>
      </Box>
      <Divider sx={{ border: "1px solid rgb(0 0 0 / 17%)", mb: "15px" }} />
      <Formik initialValues={initialValue} onSubmit={onSubmit}>
        {({ handleChange, setFieldValue, values, resetForm }) => (
          <Form>
            <Grid container spacing={"1rem"}>
              <Grid item xs={12}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Licence User Type Code
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="text"
                  name="code"
                  placeholder="Enter Licence User Type Code"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      // letterSpacing: "0.2rem",

                      "&::placeholder": {
                        // color: "green",
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Licence User Type Name
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="text"
                  name="userTypeName"
                  placeholder="Enter Licence User Type Name"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      // letterSpacing: "0.2rem",

                      "&::placeholder": {
                        // color: "green",
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <NormalTable
                  data={menusMaster}
                  columns={menusColumns}
                  filt={true}
                />
              </Grid>{" "}
              <Grid
                container
                item
                xs={12}
                justifyContent={"flex-end"}
                gap="1rem"
              >
                <Button
                  onClick={handleCancel}
                  variant="contained"
                  sx={{
                    backgroundColor: color.TableCancelButton,
                    textTransform: "none",
                    color: color.CancelTextColor,
                    ":hover": {
                      backgroundColor: color.TableCancelButton,
                      textTransform: "none",
                      color: color.CancelTextColor,
                    },
                  }}
                >
                  Cancel
                </Button>
                <Button
                  type={"submit"}
                  variant="contained"
                  disabled={loading}
                  sx={{
                    textTransform: "none",
                    backgroundColor: loading
                      ? "default"
                      : color.TableButtonColor,
                    "&:hover": {
                      backgroundColor: loading
                        ? "default"
                        : color.buttonDisable,
                    },
                  }}
                >
                  Submit
                </Button>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

export default LicenceUserTypeMenusModal;